import React from 'react';
import plusIcon from './../../../../assets/img/plus-icon.svg';
import smile from './../../../../assets/img/smilemoons.svg';


class ButtonGetPacientPhoto extends React.Component {
  constructor() {
    super();
    this.state = {
      file: null,
    }

    this.btnAddPhotoHandler = this.btnAddPhotoHandler.bind(this);
    this.handleChange = this.handleChange.bind(this)
  }

  btnAddPhotoHandler(){
    this.inputElement.click();
  }

  handleChange(event) {
    const file = event.target.files[0];
    this.setState({ file: URL.createObjectURL(file)});
    this.props.onChangeImageHandler(file, this.props.name);
  }

  render() {
    const {imageTitle} = this.props;
    return (
        <div>
          <div className="row">
            <div className="col-12 btn-getImage-title">
              <p>{imageTitle}</p>
            </div>
          </div>
          <div className="row justify-content-center text-center">
            <div className="col-md-10 get-photo-cont" 
                onClick={ this.btnAddPhotoHandler }
                >
              { this.state.file ? 
                <img src={this.state.file} className="uploadedImage" alt="imagenCargadaNoEncontrada"/>
                : null
              }
              <div>
                <img src={smile} className="smile-image" alt="Agregar foto"/>
              </div>
              <div>
                <img src={plusIcon} className="smile-image" alt="Esperando foro"/>
              </div>
              <input ref={input => this.inputElement = input} 
                name={this.props.name} 
                type="file" 
                accept="image/*" 
                className="d-none"
                onChange={this.handleChange}
              />
            </div>
          </div>
        </div>
    );
  }
}

export default ButtonGetPacientPhoto;



// WEBPACK FOOTER //
// ./src/views/Forms/Patient/QuestionsTypes/ButtonGetPacientPhoto.js